import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../../../App.css';
import '../../../Tabs.css';
import AutocompletePaginado from '../../AutocompletePaginado';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/Reply';
import 'rsuite/DatePicker/styles/index.css';
import { handleErrors, request } from '../../../utils/ApiUtils';
import Input from '../../Input';
import { showNotification } from '../../../utils/NotificationUtils';
import { getActualDate } from '../../../utils/DateUtils';
import InputMonetary from '../../InputMonetary';
import { getUserLogged, hasAnyRole } from '../../../utils/TokenUtils';
import { rolesMapping } from '../../../utils/RolesUtils';
import DespesaParcelaTab from './DespesaParcelaTab';

function DespesaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [dataArray, setDataArray] = useState([]);
    const [despesa, setDespesa] = useState({dataVencimento: getActualDate()})
    const saveTimeoutRef = useRef(null);
    const [error, setError] = useState({})
    const [isStatusCancelado, setIsStatusCancelado] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const [refreshKey, setRefreshKey] = useState(0);

    const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

    const [activeTab, setActiveTab] = useState("abaDetalhamento");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    useEffect(() => {
        loadDespesa();
    }, [id]);


    const loadDespesa = async (isRefresh) => {
        if (id) {
            request(`despesas/${id}`, {
                type: 'GET',
                callback: (data) => (
                    setDespesa(data),
                    setIsStatusCancelado(data?.status?.cancelado)
                ),
                finally: !isRefresh && agendarRefresh()
            })

        } else {
            setDespesa({dataVencimento: getActualDate()});
            setDataArray([]);
        }
    }

    const agendarRefresh = (time = 2000) => {
        if (saveTimeoutRef.current) {
            clearTimeout(saveTimeoutRef.current); // Reseta o temporizador existente
        }

        saveTimeoutRef.current = setTimeout(() => triggerRefresh(), time);
    };

    const salvarDespesa = async () => {
        despesa.usuarioUltimaAlteracao = getUserLogged();
        setIsSaving(true);

        request('despesas', {
            type: 'POST',
            body: JSON.stringify(despesa),
            callback: (data) => {
                showNotification('Despesa salva', 'success');
                setDespesa(Object.assign({}, data));
                setIsStatusCancelado(data?.status?.cancelado)
                if (!id) navigate(`/despesas/cadastro/${data.id}`);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, message, {setError}) },
            finally: () => {
                triggerRefresh();
                setIsSaving(false);
            }
        })
    };

    const atualizarStatus = async () => {
        setIsSaving(true);

        request(`despesas/${despesa.id}/updateStatus`, {
            type: 'PUT',
            body: JSON.stringify(despesa?.status),
            callback: (data) => {
                showNotification('Status atualizado com sucesso', 'success');
                setDespesa(Object.assign({}, data));
                setIsStatusCancelado(data?.status?.cancelado)
                if (!id) navigate(`/despesas/cadastro/${data.id}`);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, message, {setError}) },
            finally: () => {
                triggerRefresh();
                setIsSaving(false);
            }
        })
    };

    const handleInputChange = async (campo, valor) => {
        error[campo] = undefined;
        setError(error)

        despesa[campo] = valor;
        setDespesa({ ...despesa });
    };

    const onChangeRepeticaoAutomatica = async (repeticaoAutomatica) => {
        error['repeticaoAutomatica'] = undefined;
        setError(error)

        if (repeticaoAutomatica) {
            setDespesa({
                ...despesa,
                repeticaoAutomatica: repeticaoAutomatica,
                condicaoPagamento: { "id": 2, "condicaoPagamento": "Parcelado", "avista": false, "parcelado": true },
                quantidadeParcelas: 48
            });
        } else {

            setDespesa({
                ...despesa,
                repeticaoAutomatica: repeticaoAutomatica
            });

        }
    };

    const handleChangeCondicaoPagamento = async (valor) => {
        setError({ ...error, condicaoPagamento: undefined })

        const isPagamentoAVista = valor?.id == 1;

        const quantidadeParcelas = isPagamentoAVista ? undefined : despesa?.quantidadeParcelas;

        setDespesa((prev) => ({
            ...prev,
            condicaoPagamento: valor,
            quantidadeParcelas: quantidadeParcelas,
        }));
    };

    const isCondicaoPagamentoAVista = () => {
        return despesa?.condicaoPagamento?.id == 1;
    }

    const tabs = () => (
        <div>
            <div className="tabs">
                <div
                    className={`tab ${activeTab === "abaDetalhamento" ? "active" : ""}`}
                    onClick={() => handleTabClick("abaDetalhamento")}
                >
                    Detalhamento de Pagamentos
                </div>

            </div>

            {activeTab === "abaDetalhamento" && <div className={`tab-content active}`}>
                <DespesaParcelaTab despesa={despesa} loadDespesa={loadDespesa} despesaId={despesa?.id} refreshKey={refreshKey} despesaCancelada={isStatusCancelado} />
            </div>}
        </div>
    );

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex,",
                flexDirection: "column-reverse",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                bottom: "0,",
                right: "30px",
                maxHeight: "100vh"
            }}></div>

            <div className="header-container">
                <h1 style={{ color: 'black', fontWeight: 'bold' }}>Cadastro de Despesas</h1>
                <Button variant="text" onClick={() => navigate(`/despesas`)} startIcon={(<BackIcon style={{ fontSize: '2rem', fontWeight: 'bold', color: '#0057a3' }} />)} />
            </div>

            <div className='row-with-auto-complete' >
                <AutocompletePaginado label={"Centro de Custo*"}
                    parameters={{
                        width: '28%',
                        label: "Centro de Custo*",
                        disabled: isStatusCancelado,
                        error: error?.centroCusto,
                        bodyToSearch: { somenteAtivos: true, centroCusto: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => handleInputChange('centroCusto', itemSelecionado?.item),
                        value: despesa?.centroCusto,
                        bodyToSearch: { centroCusto: true, somenteAtivos: true }
                    }}
                    endpoint={"configdespesas/paginated"} />

                <AutocompletePaginado label={"Categoria*"}
                    parameters={{
                        width: '28%',
                        label: "Categoria*",
                        disabled: isStatusCancelado,
                        error: error?.categoria,
                        bodyToSearch: { somenteAtivos: true, categoria: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => handleInputChange('categoria', itemSelecionado?.item),
                        value: despesa?.categoria,
                        bodyToSearch: { categoria: true, somenteAtivos: true }
                    }}
                    endpoint={"configdespesas/paginated"} />

                <AutocompletePaginado label={"Colaborador"}
                    parameters={{
                        width: '28%',
                        label: "Colaborador*",
                        disabled: isStatusCancelado,
                        error: error?.colaborador,
                        bodyToSearch: { somenteAtivos: true },
                        getLabel: ((item) => item.nome),
                        onChange: (itemSelecionado) => handleInputChange('colaborador', itemSelecionado?.item),
                        value: despesa?.colaborador,
                        bodyToSearch: { colaborador: true, somenteAtivos: true }
                    }}
                    endpoint={"colaboradores/paginated"} />

                <AutocompletePaginado label={"Status*"}
                    parameters={{
                        width: '20%',
                        error: error?.status,
                        disabled: isStatusCancelado && !hasAnyRole(rolesMapping.admin),
                        bodyToSearch: { statusDespesa: true },
                        getLabel: ((item) => (item.status)),
                        onChange: (statusSelecionado) => handleInputChange('status', statusSelecionado?.item),
                        value: despesa?.status,
                        inputStyle: (status) => (
                            status ?
                            {
                                color: 'black',
                                // fontWeight: 'bold',
                                backgroundImage: `radial-gradient(circle, ${status?.item?.color || 'black'} 45%, transparent 50%)`,
                                backgroundPosition: '8px center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: '14px 14px',
                                paddingLeft: '28px'
                            }
                            : {}
                        ),
                    }}
                    endpoint={"status/status"} />
            </div>

            <div className='header-body-margin-bottom'>
                <h4 style={{ color: 'black', display: 'inline-block', textShadow: '0 6px 6px rgba(122, 116, 182, 0.5)' }}>Dados financeiros</h4>
            </div>


            <div className='row-with-auto-complete'>

                <div className="checkbox-group" style={{ width: '20%' }}>
                    <input type="checkbox" id="repeticaoAutomatica" name="repeticaoAutomatica" disabled={isStatusCancelado} checked={despesa?.repeticaoAutomatica} onClick={() => onChangeRepeticaoAutomatica(!despesa?.repeticaoAutomatica)} />
                    <label htmlFor="repeticaoAutomatica" className="checkbox-label">Repetição automática</label>
                </div>

                <InputMonetary id="valor"
                    value={despesa?.valor}
                    disabled={isStatusCancelado}
                    onChange={(value) => handleInputChange('valor', value)}
                    error={error.valor} type='decimal' width='20%' label="Valor*" />

                <AutocompletePaginado label={"Condição de Pagamento*"}
                    parameters={{
                        width: '20%',
                        label: "Condição de Pagamento*",
                        error: error?.condicaoPagamento,
                        disabled: isStatusCancelado || despesa?.repeticaoAutomatica,
                        getLabel: ((item) => (item.condicaoPagamento)),
                        onChange: (condicaoPagamentoSelecionado) => handleChangeCondicaoPagamento(condicaoPagamentoSelecionado?.item),
                        value: despesa?.condicaoPagamento
                    }}
                    endpoint={"contratos/condicoes"} />

                <Input id="quantidadeParcelas"
                    value={despesa?.quantidadeParcelas}
                    parameters={{
                        error: error.quantidadeParcelas, max: 48,
                        disabled: isCondicaoPagamentoAVista() || isStatusCancelado || despesa?.repeticaoAutomatica,
                        width: '20%', type: 'number', label: "Quantidade de Parcelas", onChange: (value) => handleInputChange('quantidadeParcelas', value)
                    }} />

                <Input id="dataVencimento"
                    value={despesa?.dataVencimento}
                    parameters={{ error: error.dataVencimento, width: '20%', disabled: isStatusCancelado, type: 'date', label: "Data de vencimento*", onChange: (value) => handleInputChange('dataVencimento', value) }} />

            </div>


            <div className='row'>            </div>


            <div className='row'>
                <Input id="observacao"
                    value={despesa?.observacao}
                    parameters={{ error: error.observacao, width: '80%', label: "Descrição da Despesa", disabled: isStatusCancelado, onChange: (value) => handleInputChange('observacao', value) }} />


                <Input id="usuarioUltimaAlteracao"
                    value={despesa?.usuarioUltimaAlteracao || ""}
                    parameters={{ error: error.usuarioUltimaAlteracao, width: '20%', label: "Última alteração", disabled: true, onChange: (value) => handleInputChange('usuarioUltimaAlteracao', value) }} />
            </div>

            {!isStatusCancelado ?

                <button onClick={() => salvarDespesa()} className="add-button" disabled={isStatusCancelado}>
                    Salvar Despesa
                </button>
                :
                hasAnyRole(rolesMapping.admin) && <button onClick={() => atualizarStatus()} className="add-button" disabled={!isStatusCancelado}>
                    Atualizar Status
                </button>
            }

            <div className='row'>            </div>

            {despesa?.id && tabs()}

        </div>
    );
}

export default DespesaForm;
